var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _path16, _g12, _path17, _g13, _path18, _g14, _path19, _g15, _path20, _g16, _path21, _g17, _path22, _g18, _path23, _g19, _path24, _g20, _path25, _g21, _path26, _g22, _path27, _g23, _path28, _g24, _path29, _g25, _path30, _g26, _path31, _g27, _path32, _g28, _path33, _g29, _path34, _g30, _path35, _g31, _path36, _g32, _path37, _g33, _path38, _g34, _path39, _g35, _path40, _g36, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllsponsor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 159,
    viewBox: "0 0 257 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61768 28.3643H103.651V1.89648H6.61768V28.3643Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36928,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80176 26.1715H101.467V4.08887H8.80176V26.1715Z",
    fill: "#F8E146",
    stroke: "#F8E146",
    strokeWidth: 0.36928,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1268 13.504C14.3738 12.8613 12.6039 11.1594 12.6417 9.4959C12.6417 8.96657 13.2437 7.94567 14.7503 7.98344C16.2564 8.02121 17.6875 8.9288 19.6451 11.0461C21.6032 13.164 26.7995 19.2522 27.5141 20.0837C28.456 21.1424 28.9075 22.1627 32.9742 22.1627H95.5935M95.0653 16.6805C95.8189 17.2854 97.5882 18.9867 97.5505 20.6502C97.5505 21.2179 96.9479 22.2388 95.4418 22.1633C93.9358 22.1261 92.5047 21.2563 90.5471 19.1006C88.5884 16.9838 83.3921 10.8956 82.6769 10.1014C81.7361 9.00492 81.2847 7.98402 77.2545 7.98402H14.637M14.9763 13.3907C13.4331 12.0676 12.7928 10.7062 13.4331 9.9497C13.9601 9.42036 16.1065 9.68474 17.8008 11.3111C19.4951 12.8991 19.6834 14.3732 19.3075 14.7898C18.9681 15.2064 16.8973 14.9031 15.6922 13.9578C15.3529 13.7311 14.9763 13.3907 14.9763 13.3907ZM95.2542 16.7555C96.7602 18.1175 97.4 19.4405 96.7974 20.1976C96.2332 20.7263 94.0863 20.462 92.3919 18.8734C90.6976 17.286 90.5477 15.7729 90.8859 15.3575C91.2252 14.9798 93.296 15.2442 94.5006 16.2267C94.8399 16.4162 95.2542 16.7555 95.2542 16.7555Z",
    stroke: "black",
    strokeWidth: 0.465124,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1104 9.72363H18.1771M19.0045 14.9414H23.109M87.1205 15.207H91.3749M92.0535 20.4625H96.1569",
    stroke: "black",
    strokeWidth: 0.498246,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2824 11.1987H17.6124M14.111 12.5218H18.7803M15.6165 13.8454H22.0928M19.4949 14.2992H22.4699M19.0051 12.7484H21.0388M17.8384 11.312H19.721M17.0098 10.5939H19.0807M12.6421 9.64851H13.9605M12.7176 9.15636H17.4996M13.0186 8.58984H16.7838M17.4241 8.93034H81.435M82.3768 9.98842H18.5542M19.3822 10.6694H28.231M19.9848 11.4253H28.231M20.5867 12.1435H28.231M21.3409 12.9H28.2315M21.8673 13.6182H28.2315M22.6582 14.4508H28.2315M23.449 15.2446H28.231M24.5785 16.6437H28.2315M25.5948 17.7401H28.231M26.4611 18.7988H28.231M27.1764 19.6309H28.231M27.9672 20.5001H92.0164M28.8335 21.2944H92.9577M95.2917 16.8709H91.0373M96.4207 18.0423H91.6771M81.6238 11.2365H83.6191M84.4483 12.2196H81.6238M85.615 13.5049H81.6238M86.3686 14.3364H81.6238M86.8573 14.9418H81.6232M90.7352 16.1527H88.0624M90.8491 16.7187H88.4011M91.1495 17.173H88.8526M88.1379 16.4921H81.6238M89.0037 17.3625H81.6238M89.4551 17.8912H81.6232M81.6238 18.6094H90.0955M90.5097 19.1771H81.6238M91.2256 19.8191H81.6238M91.4516 19.933H93.9745M90.9612 19.4414H93.071M90.5481 18.9877H92.4295M90.0577 18.4961H92.0164M92.8438 21.1811H97.3626",
    stroke: "black",
    strokeWidth: 0.332634,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1214 17.1725V10.8193H33.3893V16.8703C33.3893 17.5874 32.5985 17.8907 32.1092 17.8907C31.8077 17.8907 30.7159 17.3991 30.4149 17.1725L29.7368 18.4955C29.7368 18.4955 30.9041 19.5542 32.2969 19.5542C33.6525 19.5542 34.2928 18.8732 34.5182 18.6088C34.7826 18.3445 35.1214 17.6635 35.1214 17.1725ZM36.8529 19.5542C37.4182 19.5542 37.8325 19.1387 37.8325 18.5716C37.8325 18.0417 37.4182 17.5879 36.8529 17.5879C36.3259 17.5879 35.8744 18.0417 35.8744 18.5716C35.8732 18.7007 35.8977 18.8286 35.9464 18.9481C35.9952 19.0675 36.0671 19.1761 36.1582 19.2675C36.2492 19.359 36.3575 19.4314 36.4768 19.4806C36.596 19.5298 36.7239 19.5548 36.8529 19.5542ZM47.6597 19.5542C48.2245 19.5542 48.6766 19.1387 48.6766 18.5716C48.6766 18.0417 48.2245 17.5879 47.6597 17.5879C47.1327 17.5879 46.6807 18.0417 46.6807 18.5716C46.6807 19.1387 47.1327 19.5542 47.6597 19.5542ZM41.8609 19.517H40.0916V10.8193H43.4803C45.1746 10.8193 45.8527 12.2946 45.8527 12.8995C45.8527 13.5043 45.9654 14.4119 44.8359 15.0546C45.9277 15.5845 46.1543 16.3776 46.1543 17.0964C46.1543 17.8151 45.5889 19.517 43.4053 19.517H41.8609ZM43.2171 17.9668C43.7441 17.9668 44.1961 17.5502 44.1961 17.0214C44.1961 16.4915 43.7441 16.0389 43.2171 16.0389H41.8615V17.9668H43.2171ZM43.0666 14.4503C43.5558 14.4503 43.9701 14.072 43.9701 13.5427C43.9701 13.0511 43.5564 12.6351 43.0666 12.6351H41.8615V14.4503H43.0666ZM56.2447 10.8193V14.4875H53.7224V10.8193H51.9525V19.517H53.7224V15.9999H56.2447V19.517H57.9762V10.8193H56.2447ZM62.9099 17.8907C63.5502 17.8907 64.0388 17.3619 64.0388 16.7181V10.8193H65.696V16.0383C65.696 17.3991 65.847 18.0411 65.2067 18.7221C64.6042 19.4031 63.7007 19.7436 62.9099 19.7436C62.1191 19.7436 61.2155 19.4031 60.5752 18.7221C59.9349 18.0411 60.086 17.3991 60.086 16.0383V10.8193H61.742V16.7181C61.742 17.3619 62.2696 17.8907 62.9099 17.8907ZM79.8166 10.8193H74.3942V12.4463H76.2013V19.517H78.0089V12.4463H79.8166V10.8193ZM71.532 19.4792L69.1979 14.7147V19.517H67.5408V10.8193H69.1979L71.457 15.0174V10.8193H73.1142V19.517H71.532V19.4792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.567 28.7809C107.934 28.7809 108.297 28.7085 108.636 28.5677C108.975 28.4269 109.283 28.2206 109.541 27.9606C109.8 27.7006 110.005 27.392 110.145 27.0526C110.284 26.7131 110.355 26.3495 110.353 25.9826C110.353 24.4696 109.11 23.2227 107.567 23.2227C106.023 23.2227 104.78 24.4696 104.78 25.9826C104.778 26.3496 104.849 26.7133 104.989 27.0527C105.128 27.3922 105.333 27.7008 105.592 27.9608C105.851 28.2208 106.159 28.4271 106.498 28.5679C106.837 28.7086 107.2 28.781 107.567 28.7809ZM107.567 28.1C106.362 28.1 105.533 27.2307 105.533 25.982C105.533 24.7351 106.362 23.8653 107.567 23.8653C108.771 23.8653 109.6 24.7345 109.6 25.982C109.6 27.2307 108.771 28.1 107.567 28.1ZM108.207 26.247C108.734 26.2098 109.036 25.9826 109.036 25.4149C109.036 24.6968 108.659 24.5079 107.868 24.5079H106.437V27.4951H107.077V26.247H107.568L108.208 27.4951H108.96L108.207 26.247ZM107.077 25.7938V24.9617H107.754C108.019 24.9617 108.47 24.9245 108.47 25.3394C108.47 25.7171 108.207 25.7932 107.867 25.7932H107.077V25.7938Z",
    fill: "#0C0E0F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.381 12.3957C235.005 12.3957 235.518 12.0725 235.588 11.6551L236.203 4.71575C236.203 4.02987 235.397 3.4668 234.383 3.4668C233.37 3.4668 232.564 4.02986 232.564 4.71587L233.18 11.6551C233.248 12.0724 233.761 12.3957 234.383 12.3957H234.381ZM230.617 14.5631C230.93 14.0256 230.906 13.4214 230.576 13.153L224.851 9.15196C224.256 8.80852 223.364 9.22191 222.857 10.0971C222.349 10.9712 222.439 11.9474 223.033 12.2909L229.372 15.2316C229.768 15.3779 230.308 15.0962 230.619 14.5591L230.617 14.5631ZM238.149 14.5594C238.461 15.0966 238.999 15.3784 239.395 15.2319L245.734 12.2913C246.332 11.9479 246.416 10.9715 245.913 10.0975C245.404 9.22315 244.51 8.80889 243.916 9.15233L238.191 13.1534C237.864 13.4214 237.84 14.0261 238.151 14.5635L238.149 14.5594ZM234.381 21.0639C235.005 21.0639 235.518 21.3843 235.588 21.8022L236.203 28.7405C236.203 29.4285 235.397 29.9903 234.383 29.9903C233.37 29.9903 232.564 29.4285 232.564 28.7405L233.18 21.8022C233.248 21.3843 233.761 21.0639 234.383 21.0639H234.381ZM238.149 18.896C238.461 18.3573 238.999 18.078 239.395 18.2261L245.734 21.1647C246.332 21.5085 246.416 22.4857 245.913 23.3605C245.404 24.232 244.51 24.6474 243.916 24.3044L238.191 20.3071C237.864 20.037 237.84 19.4319 238.151 18.8949H238.148M230.617 18.8952C230.93 19.4319 230.906 20.037 230.576 20.3076L224.851 24.3048C224.256 24.6477 223.364 24.2324 222.857 23.3609C222.349 22.4861 222.439 21.5089 223.033 21.1651L229.372 18.2264C229.768 18.0784 230.308 18.3577 230.619 18.8965H230.617",
    fill: "#FDBB30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.271 20.2945C198.271 20.5074 198.252 20.727 198.193 20.9199C197.95 21.7211 197.118 22.3986 196.076 22.3986C195.208 22.3986 194.518 21.907 194.518 20.8689C194.518 19.2801 196.273 18.8414 198.271 18.8524L198.271 20.2943V20.2945ZM201.404 17.5257C201.404 14.9058 200.281 12.6006 196.484 12.6006C194.536 12.6006 192.989 13.1459 192.145 13.632L192.763 15.7382C193.535 15.2529 194.764 14.8511 195.928 14.8511C197.854 14.8458 198.169 15.9376 198.169 16.6364V16.8018C193.971 16.7956 191.318 18.2437 191.318 21.1938C191.318 22.9964 192.669 24.6847 195.019 24.6847C196.462 24.6847 197.671 24.1107 198.395 23.1902H198.466C198.466 23.1902 198.945 25.1886 201.588 24.424C201.45 23.5929 201.405 22.7057 201.405 21.6389L201.405 17.5257M136 9.03272C136 9.03272 138.743 20.2315 139.181 22.0489C139.692 24.1703 140.613 24.9513 143.267 24.424L144.98 17.4812C145.414 15.7559 145.705 14.5257 145.984 12.7724H146.033C146.23 14.5443 146.508 15.7612 146.866 17.4869C146.866 17.4869 147.562 20.639 147.92 22.2941C148.278 23.9486 149.274 24.992 151.874 24.424L155.955 9.03223H152.661L151.267 15.6872C150.892 17.6235 150.552 19.1382 150.29 20.9093H150.244C150.005 19.1538 149.702 17.7009 149.321 15.8138L147.871 9.03223H144.438L142.886 15.6428C142.447 17.6522 142.035 19.2741 141.774 20.9862H141.727C141.459 19.374 141.102 17.3348 140.716 15.3906C140.716 15.3906 139.795 10.6621 139.471 9.03223L136 9.03272ZM162.186 20.2945C162.186 20.5074 162.167 20.727 162.108 20.9199C161.866 21.7211 161.033 22.3986 159.991 22.3986C159.122 22.3986 158.434 21.907 158.434 20.8689C158.434 19.2801 160.188 18.8414 162.187 18.8524L162.186 20.2943V20.2945ZM165.32 17.5257C165.32 14.9058 164.196 12.6006 160.401 12.6006C158.451 12.6006 156.903 13.1459 156.06 13.632L156.677 15.7382C157.449 15.2529 158.678 14.8511 159.842 14.8511C161.769 14.8458 162.085 15.9376 162.085 16.6364V16.8018C157.885 16.7956 155.233 18.2437 155.233 21.1938C155.233 22.9964 156.584 24.6847 158.931 24.6847C160.377 24.6847 161.585 24.1107 162.31 23.1902H162.38C162.38 23.1902 162.86 25.1886 165.503 24.424C165.365 23.5929 165.32 22.7057 165.32 21.6389V17.5257ZM170.55 21.1568V9.03272H167.412V24.4245H170.55V21.1568ZM211.595 9.03272V20.387C211.595 21.9531 211.892 23.0491 212.524 23.7199C213.077 24.3064 213.987 24.686 215.078 24.686C216.006 24.686 216.918 24.5096 217.349 24.3505L217.308 21.9083C216.988 21.9863 216.62 22.0494 216.117 22.0494C215.048 22.0494 214.69 21.367 214.69 19.9617V15.6173H217.422V12.672H214.69V9.03272H211.595ZM203.497 12.8617V24.4245H206.733V18.5041C206.733 18.1841 206.753 17.9053 206.804 17.6502C207.043 16.4094 207.995 15.6173 209.362 15.6173C209.737 15.6173 210.005 15.6579 210.296 15.699V12.672C210.052 12.6236 209.886 12.6009 209.583 12.6009C208.375 12.6009 207.001 13.3774 206.424 15.0431H206.337V12.8617H203.497ZM172.746 12.8617V24.4245H175.9V17.644C175.9 17.3259 175.937 16.9894 176.048 16.6977C176.309 16.015 176.947 15.2155 177.965 15.2155C179.238 15.2155 179.832 16.2872 179.832 17.8341V24.4236H182.983V17.5606C182.983 17.257 183.025 16.891 183.115 16.6234C183.374 15.8464 184.06 15.2146 185.007 15.2146C186.297 15.2146 186.916 16.2676 186.916 18.0883V24.4233H190.069V17.6127C190.069 14.0215 188.238 12.5998 186.172 12.5998C185.258 12.5998 184.535 12.828 183.882 13.2269C183.333 13.5636 182.841 14.0408 182.412 14.668H182.365C181.867 13.4219 180.694 12.6004 179.167 12.6004C177.204 12.6004 176.322 13.5917 175.787 14.4324H175.74V12.8613H172.746",
    fill: "#1A75CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.325 23.863H247.372C247.435 23.863 247.476 23.837 247.476 23.7984C247.476 23.7545 247.438 23.7306 247.379 23.7306C247.359 23.7306 247.338 23.7347 247.325 23.7347V23.8642V23.8629L247.325 23.863ZM247.317 24.1748H247.15V23.6307C247.188 23.6232 247.276 23.61 247.39 23.61C247.513 23.61 247.569 23.6273 247.609 23.6545C247.643 23.6783 247.668 23.7189 247.668 23.7738C247.668 23.8296 247.617 23.8769 247.54 23.8976V23.9045C247.602 23.921 247.636 23.9658 247.654 24.0444C247.671 24.1229 247.681 24.155 247.692 24.1752H247.502C247.486 24.155 247.476 24.1068 247.465 24.0588C247.454 24.0037 247.428 23.9761 247.372 23.9761H247.317L247.317 24.1748ZM247.387 23.4534C247.146 23.4534 246.964 23.6487 246.964 23.8978C246.964 24.1405 247.146 24.3385 247.393 24.3385C247.641 24.3425 247.823 24.1406 247.823 23.8939C247.823 23.6482 247.641 23.4534 247.39 23.4534H247.387ZM247.397 23.3057C247.733 23.3057 248 23.5689 248 23.8937C248 24.2224 247.733 24.486 247.393 24.486C247.053 24.486 246.782 24.2221 246.782 23.8939C246.782 23.5689 247.053 23.3058 247.393 23.3058H247.396",
    fill: "#FDBB30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8361 73.8765H68.742L71.5143 76.9477L74.184 73.8765H79.8839L74.3129 80.1731L79.9603 86.521H74.0302L71.2829 83.4246L68.5617 86.521H62.8361L68.4335 80.1992L62.8361 73.8765ZM56.4965 73.8765H62.8361V78.1482H56.4965V82.0692H62.8361V86.521H51.8369V66.6025H62.8361V71.0421H56.4965V73.8765Z",
    fill: "#FF6600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1969 66.6025V74.7541H47.1459C46.1187 73.5673 44.8352 73.1549 43.346 73.1549C40.2956 73.1549 37.9978 75.2393 37.1912 77.9951C36.2713 74.9586 33.8991 73.098 30.3814 73.098C27.5248 73.098 25.269 74.3869 24.0918 76.4871V73.8768H18.187V71.0427H24.6307V66.6025H12.9233V86.5213H18.187V78.1482H23.4334C23.2719 78.7918 23.1913 79.4531 23.1935 80.1168C23.1935 84.2718 26.3513 87.1872 30.3814 87.1872C33.7704 87.1872 36.0037 85.5879 37.185 82.6723H32.6743C32.0641 83.5481 31.6013 83.8083 30.3814 83.8083C28.967 83.8083 27.7474 82.5678 27.7474 81.0974H36.9323C37.3307 84.3976 39.8882 87.2438 43.398 87.2438C44.912 87.2438 46.2981 86.4952 47.1459 85.2313H47.1969V86.5207H51.8369V66.6025H47.1969ZM27.8939 78.2078C28.1866 76.9427 29.1628 76.1158 30.3814 76.1158C31.723 76.1158 32.6495 76.9171 32.8932 78.2078H27.8939ZM44.3811 83.4883C42.6707 83.4883 41.6079 81.8864 41.6079 80.2139C41.6079 78.426 42.5324 76.7068 44.3811 76.7068C46.2981 76.7068 47.0618 78.426 47.0618 80.2139C47.0615 81.9093 46.2523 83.4883 44.3811 83.4883Z",
    fill: "#652C8F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3693_13671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.351 54.5C129.036 54.5 123.006 55.8913 117.691 58.7083V80.4566C117.691 85.1025 119.439 88.9909 122.745 91.7014C125.727 94.1447 135.269 98.3317 136.351 98.8018C137.433 98.3311 146.975 94.1447 149.957 91.7014C153.263 88.9899 155.011 85.102 155.011 80.4566V58.7093C149.696 55.8913 143.666 54.5 136.351 54.5Z",
    fill: "#1E0000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 54,
    width: 37,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.072 58.9378V80.4566C118.072 84.9838 119.771 88.7711 122.987 91.4064C125.928 93.8182 135.277 97.9209 136.351 98.387C137.424 97.9209 146.774 93.8182 149.715 91.4069C152.931 88.7716 154.63 84.9838 154.63 80.4571V58.9378C149.553 56.2452 143.402 54.8809 136.351 54.8809C129.3 54.8809 123.15 56.2457 118.072 58.9389",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.072 54.8818H154.63V98.3865H118.072V54.8818Z",
    fill: "url(#paint0_radial_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.019 95.9165V97.7835H148.357V97.0046H148.405C148.43 97.0422 148.913 97.7835 148.913 97.7835H149.32L148.758 96.961C149.005 96.9031 149.172 96.7238 149.172 96.4649C149.172 96.1998 149.008 95.9165 148.55 95.9165H148.019ZM148.51 96.1892C148.796 96.1892 148.834 96.3293 148.834 96.4512C148.834 96.6274 148.759 96.7441 148.398 96.7441H148.357V96.1892H148.51ZM149.829 96.8553C149.829 97.55 149.263 98.1166 148.563 98.1166C147.866 98.1166 147.299 97.55 147.299 96.8553C147.299 96.1587 147.866 95.5885 148.563 95.5885C149.263 95.5885 149.829 96.1592 149.829 96.8558M148.562 95.3184C147.716 95.3184 147.028 96.0104 147.028 96.8558C147.028 97.7013 147.716 98.3893 148.562 98.3893C149.412 98.3893 150.098 97.7013 150.098 96.8558C150.098 96.0104 149.413 95.3184 148.562 95.3184Z",
    fill: "#C86E14"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 59,
    width: 34,
    height: 38
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.722 71.6476V81.4189C135.95 81.5037 136.323 81.6108 136.754 81.6108C138.585 81.6108 139.459 79.9311 139.459 76.4545C139.459 72.8916 138.694 71.4186 136.849 71.4186C136.417 71.4186 135.98 71.5201 135.722 71.6471M127.734 81.166V69.1799H130.908V82.9756C129.693 83.8013 128.063 84.2532 126.117 84.2532C122.97 84.2532 121.374 82.5461 121.374 79.1756V69.1799H124.553V79.3173C124.553 80.2195 124.771 81.5549 126.228 81.5549C126.875 81.5549 127.388 81.4041 127.733 81.166M132.54 69.9887C133.693 69.2444 135.092 68.8575 136.827 68.8575C140.623 68.8575 142.709 71.7375 142.709 76.3738C142.709 81.0187 140.683 84.1983 137.153 84.1983C136.5 84.1983 136.039 84.112 135.722 84.0181V90.7139H132.54V69.9892V69.9887ZM148.514 79.8595C148.491 78.8608 147.926 78.3195 146.529 77.4985C143.905 75.9589 143.434 74.6936 143.43 73.0018C143.416 70.4325 145.604 68.9184 147.696 68.8575C149.443 68.8041 150.626 69.4602 151.186 69.8902V72.6555C150.523 71.9751 149.448 71.3587 148.337 71.3485C147.436 71.3404 146.498 71.7369 146.467 72.8682C146.436 74.0249 147.372 74.4829 148.559 75.1775C151.215 76.7394 151.729 78.1428 151.668 79.9982C151.607 82.0312 150.206 84.2532 147.064 84.2532C145.807 84.2532 144.564 83.8602 143.568 83.2656V80.3373C144.38 81.0609 145.594 81.624 146.608 81.6311H146.621C147.781 81.6311 148.542 80.9644 148.515 79.859M119.752 68.1491V80.4572C119.752 84.4664 121.235 87.8146 124.052 90.1096C126.538 92.1356 134.193 95.5985 136.351 96.5531C138.482 95.6137 146.117 92.1935 148.647 90.1096C151.483 87.774 152.951 84.504 152.951 80.4572V59.3903C150.693 59.1801 148.348 59.042 145.959 59.042C137.1 59.042 127.603 60.9461 119.751 68.1481",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.751 59.042H152.951V96.5531H119.751V59.042Z",
    fill: "url(#paint1_radial_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 80,
    width: 18,
    height: 17
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.751 80.457C119.751 84.4663 121.234 87.8144 124.051 90.1095C126.538 92.1355 134.193 95.5984 136.351 96.5529V96.3026C134.559 95.5095 126.713 91.9841 124.195 89.9323C121.438 87.6855 119.979 84.4089 119.979 80.457H119.751H119.751Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.341 104.847L111.708 88.7851L127.762 72.1621L144.394 88.2235",
    fill: "url(#paint2_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 80,
    width: 17,
    height: 17
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.722 80.457C152.722 84.4378 151.303 87.6266 148.502 89.9328C146.067 91.9384 138.705 95.2643 136.351 96.3026V96.5524C138.481 95.6131 146.116 92.1928 148.647 90.109C151.483 87.7738 152.951 84.5039 152.951 80.457H152.722Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.309 88.2235L144.941 72.1621L160.994 88.7851L144.361 104.847",
    fill: "url(#paint3_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 59,
    width: 34,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.751 68.1481L119.98 68.2486C126.606 62.2084 135.105 59.2705 145.959 59.2705C148.078 59.2705 150.293 59.3781 152.722 59.5985L152.951 59.3903C150.693 59.1801 148.348 59.042 145.959 59.042C137.1 59.042 127.603 60.9461 119.751 68.1481Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.892 60.0377L149.36 48.7314L155.809 67.2529L123.342 78.5597",
    fill: "url(#paint4_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 76,
    width: 4,
    height: 6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.23 76.4551C139.23 79.2655 138.677 81.3834 136.754 81.3834V81.6119C138.585 81.6119 139.459 79.9312 139.459 76.4551H139.23Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.685 80.5701L137.3 75.3691L141.528 77.4951L138.913 82.6961",
    fill: "url(#paint5_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 81,
    width: 2,
    height: 1
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.723 81.4194C135.95 81.5042 136.323 81.6113 136.754 81.6113V81.3828C136.442 81.3828 136.161 81.3219 135.951 81.2559L135.723 81.4194Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.739 81.7361L135.679 81.6061L135.738 81.1309L136.797 81.2608",
    fill: "url(#paint6_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 71,
    width: 2,
    height: 1
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.723 71.6479L135.951 71.7987C136.173 71.7175 136.503 71.6474 136.85 71.6474V71.4189C136.418 71.4189 135.981 71.5205 135.723 71.6474",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.629 71.4437L136.776 71.1426L136.942 71.7747L135.794 72.0743",
    fill: "url(#paint7_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 71,
    width: 4,
    height: 6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.849 71.6479C138.723 71.6479 139.23 73.3997 139.23 76.4549H139.459C139.459 72.8919 138.694 71.4189 136.849 71.4189V71.6474V71.6479Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.383 77.5078L134.817 72.4506L138.924 70.3662L141.49 75.4245",
    fill: "url(#paint8_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 68,
    width: 5,
    height: 6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.202 73.0032L143.43 73.0017C143.417 70.4325 145.604 68.9183 147.697 68.8574L147.69 68.6289C145.377 68.6964 143.188 70.3883 143.201 73.0027",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.874 71.0368L145.215 75.2461L141.012 70.5951L145.671 66.3857",
    fill: "url(#paint9_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 71,
    width: 3,
    height: 2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.468 72.8688L146.696 72.8739C146.704 72.5692 146.846 71.5771 148.307 71.5771L148.338 71.3496H148.31C147.419 71.3496 146.499 71.7497 146.468 72.8693",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.713 72.0055L147.533 70.4229L149.094 72.2178L147.273 73.8005",
    fill: "url(#paint10_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 71,
    width: 4,
    height: 3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.307 71.5771C149.622 71.5771 150.745 72.4327 151.415 73.2187L151.187 72.6566C150.524 71.9762 149.449 71.3598 148.338 71.3496L148.307 71.5781V71.5771Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.752 74.4921L147.541 72.8206L148.97 70.0771L152.181 71.7487",
    fill: "url(#paint11_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 68,
    width: 5,
    height: 2
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 68.6291L147.698 68.8576C149.444 68.8042 150.627 69.4603 151.187 69.8903L151.415 69.7776C150.936 69.3892 149.717 68.625 147.892 68.625C147.825 68.625 147.758 68.6265 147.69 68.6286",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.042 67.5361L151.785 68.7446L151.063 70.9787L147.321 69.7703",
    fill: "url(#paint12_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 79,
    width: 5,
    height: 6
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.064 84.2535V84.482C149.947 84.482 151.821 82.5627 151.898 80.0071L151.67 79.999C151.609 82.0321 150.206 84.254 147.064 84.254",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.138 82.2874L149.431 86.8978L144.824 82.1934L149.532 77.583",
    fill: "url(#paint13_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 83,
    width: 5,
    height: 2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.34 83.3961C144.477 84.075 145.699 84.4827 147.064 84.4827V84.2542C145.807 84.2542 144.564 83.8612 143.568 83.2666L143.34 83.3961Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.626 82.2734L147.388 83.36L146.778 85.4743L143.015 84.3888",
    fill: "url(#paint14_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 79,
    width: 4,
    height: 3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.568 80.3379C144.38 81.0615 145.594 81.6246 146.608 81.6317L146.609 81.4032C145.477 81.3951 144.169 80.6669 143.339 79.8281L143.568 80.3384L143.568 80.3379Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.986 82.9168L142.631 81.2869L143.964 78.543L147.319 80.1719",
    fill: "url(#paint15_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 79,
    width: 3,
    height: 3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.287 79.8655C148.312 80.88 147.602 81.4101 146.61 81.403L146.608 81.6314C147.774 81.6365 148.542 80.9683 148.515 79.8594L148.286 79.8655H148.287Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.724 80.6736L147.657 78.8965L149.428 80.8224L147.495 82.5996",
    fill: "url(#paint16_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 73,
    width: 6,
    height: 7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.202 73.0035C143.207 74.7847 143.734 76.1231 146.413 77.6952C147.846 78.537 148.266 79.024 148.286 79.8658L148.515 79.8607C148.49 78.8605 147.926 78.3197 146.528 77.4981C143.906 75.9596 143.435 74.6938 143.431 73.002L143.202 73.003L143.202 73.0035Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.784 70.5117L151.731 77.6305L144.931 82.3552L139.984 75.2374",
    fill: "url(#paint17_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 72,
    width: 6,
    height: 9
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.56 75.1779C151.215 76.7398 151.729 78.1432 151.669 79.9986L151.897 80.0067C151.959 78.1107 151.442 76.6083 148.675 74.9814C147.551 74.3 146.667 73.9288 146.696 72.8742L146.467 72.8691C146.436 74.0253 147.372 74.4828 148.559 75.1779",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.033 70.2363L155.361 77.5176L148.363 82.6388L143.034 75.3586",
    fill: "url(#paint18_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.723 90.7139H132.541L132.312 90.9424H135.951",
    fill: "#8F4A02"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 84,
    width: 3,
    height: 1
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.951 84.311C136.31 84.3882 136.713 84.4278 137.154 84.4278V84.1993C136.501 84.1993 136.04 84.112 135.723 84.0186L135.951 84.3115V84.311Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.756 83.8018L137.215 84.0277L137.12 84.6436L135.661 84.4177",
    fill: "url(#paint19_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 76,
    width: 6,
    height: 9
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.709 76.374C142.709 81.019 140.683 84.1986 137.153 84.1986V84.4271C141.251 84.4271 142.938 80.5122 142.938 76.374H142.709Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.75 79.1028L140.976 87.1644L133.342 81.6984L139.114 73.6357",
    fill: "url(#paint20_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 68,
    width: 5,
    height: 2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M132.312 69.8638L132.541 69.9887C133.694 69.2443 135.093 68.8574 136.827 68.8574V68.6289C135.066 68.6289 133.532 69.0326 132.312 69.8638Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.157 69.9034L132.595 71.0839L131.982 68.7142L136.545 67.5342",
    fill: "url(#paint21_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 68,
    width: 7,
    height: 9
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.828 68.8574C140.624 68.8574 142.71 71.7374 142.71 76.3737H142.938C142.938 72.2721 141.222 68.6289 136.829 68.6289V68.8574H136.828Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.613 65.6621L146.698 73.4247L139.154 79.3401L133.067 71.578",
    fill: "url(#paint22_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.554 69.1797H121.374L121.146 68.9512H124.782L124.554 69.1797ZM130.909 69.1797H127.735L127.506 68.9512H131.138L130.909 69.1797Z",
    fill: "#FFC20E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.752 80.4575V68.1475L119.98 68.248V80.456H119.752V80.4575ZM151.416 73.2184V69.7779L151.187 69.8906V72.6553L151.416 73.2184ZM124.781 79.3176V68.9517L124.553 69.1802V79.3171L124.781 79.3176Z",
    fill: "#D78817"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.722 80.4575V59.5988L152.951 59.3906V80.4575H152.722ZM143.34 79.8279V83.3954L143.569 83.2659V80.3382L143.34 79.8289V79.8279ZM127.734 81.1663V69.1802L127.506 68.9517V81.0414L127.734 81.1663ZM121.375 79.1759V69.1802L121.146 68.9517V79.1764L121.375 79.1759Z",
    fill: "#D89016"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 79,
    width: 6,
    height: 6
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.146 79.1758C121.146 82.5422 122.725 84.4818 126.117 84.4818V84.2534C122.97 84.2534 121.375 82.5463 121.375 79.1758H121.146Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.814 76.6973L128.763 82.0236L123.45 86.9611L118.5 81.6347",
    fill: "url(#paint23_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 82,
    width: 6,
    height: 3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M126.117 84.2536V84.4821C128.148 84.4821 129.789 84.0129 131.137 83.0974L130.908 82.9756C129.693 83.8012 128.063 84.2531 126.117 84.2531",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.502 84.3879L126.432 85.6989L125.751 83.0708L130.822 81.7598",
    fill: "url(#paint24_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 81,
    width: 2,
    height: 1
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M126.229 81.3265V81.5549C126.875 81.5549 127.388 81.4041 127.734 81.166L127.505 81.0391C127.183 81.2254 126.735 81.3265 126.229 81.3265Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.111 81.0692L127.648 80.6914L127.853 81.5251L126.315 81.9034",
    fill: "url(#paint25_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 79,
    width: 3,
    height: 3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.553 79.3174C124.553 80.2197 124.772 81.5551 126.229 81.5551V81.3266C125.108 81.3266 124.782 80.4228 124.782 79.3174H124.553Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.138 82.3536L123.487 80.0977L125.645 78.5186L127.296 80.7745",
    fill: "url(#paint26_linear_3693_13671)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.312 69.8643V90.9428L132.541 90.7143V69.9892",
    fill: "#D78817"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_3693_13671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 47,
    width: 53,
    height: 59
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 47.4551H162.247V105.847H110.456V47.4551Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_3693_13671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.951 81.2551V71.7977L135.723 71.6469V81.4176L135.951 81.2551ZM135.951 84.3118V90.9432L135.723 90.7147V84.0174L135.951 84.3118ZM131.138 83.0973V68.9512L130.909 69.1797V82.9754",
    fill: "#BF7312"
  })))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8471 148.036C56.0539 152.3 47.6568 154.575 40.4272 154.575C30.29 154.575 21.1639 150.831 14.2597 144.604C13.7173 144.115 14.2033 143.447 14.8542 143.829C22.3052 148.158 31.5181 150.762 41.0347 150.762C47.4529 150.762 54.5133 149.436 61.0053 146.684C61.986 146.268 62.8062 147.326 61.8471 148.036Z",
    fill: "#FF9900"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2556 145.284C63.5178 144.34 59.3606 144.838 57.4946 145.059C56.9261 145.128 56.8393 144.634 57.3514 144.279C60.6624 141.952 66.0955 142.624 66.7291 143.404C67.3627 144.188 66.5642 149.626 63.4528 152.222C62.9754 152.621 62.5198 152.408 62.7324 151.88C63.4311 150.138 64.9976 146.233 64.2556 145.284Z",
    fill: "#FF9900"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M57.625 127.852V125.59C57.625 125.247 57.8854 125.018 58.1978 125.018H68.3393C68.6648 125.018 68.9252 125.252 68.9252 125.59V127.527C68.9208 127.852 68.6475 128.276 68.1614 128.948L62.9062 136.44C64.859 136.393 66.9203 136.683 68.6908 137.68C69.0901 137.905 69.1986 138.234 69.229 138.559V140.973C69.229 141.302 68.8644 141.688 68.4825 141.489C65.3624 139.855 61.2182 139.677 57.7682 141.506C57.4167 141.697 57.0479 141.315 57.0479 140.986V138.694C57.0479 138.325 57.0522 137.697 57.4211 137.138L63.5094 128.419H58.2109C57.8854 128.419 57.625 128.19 57.625 127.852Z",
    fill: "#221F1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6302 141.965H17.5448C17.2497 141.943 17.0154 141.722 16.9937 141.44V125.628C16.9937 125.312 17.2584 125.06 17.5882 125.06H20.4653C20.7647 125.073 21.0034 125.303 21.0251 125.589V127.656H21.0815C21.8322 125.658 23.2426 124.727 25.1433 124.727C27.0744 124.727 28.2808 125.658 29.1487 127.656C29.8951 125.658 31.5919 124.727 33.4101 124.727C34.7033 124.727 36.118 125.26 36.9816 126.456C37.958 127.786 37.7584 129.719 37.7584 131.413L37.754 141.393C37.754 141.709 37.4893 141.965 37.1595 141.965H34.0784C33.7703 141.943 33.523 141.696 33.523 141.393V133.012C33.523 132.345 33.5837 130.681 33.4362 130.048C33.2062 128.986 32.5162 128.687 31.6223 128.687C30.8759 128.687 30.0947 129.186 29.7779 129.983C29.4612 130.78 29.4915 132.115 29.4915 133.012V141.393C29.4915 141.709 29.2268 141.965 28.897 141.965H25.8159C25.5035 141.943 25.2605 141.696 25.2605 141.393L25.2561 133.012C25.2561 131.248 25.5469 128.653 23.3554 128.653C21.1379 128.653 21.2247 131.183 21.2247 133.012V141.393C21.2247 141.709 20.96 141.965 20.6302 141.965Z",
    fill: "#221F1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6562 124.727C82.2344 124.727 84.7123 128.653 84.7123 133.645C84.7123 138.468 81.974 142.294 77.6562 142.294C73.1604 142.294 70.7129 138.368 70.7129 133.476C70.7129 128.553 73.1908 124.727 77.6562 124.727ZM77.6822 127.955C75.4083 127.955 75.2651 131.049 75.2651 132.977C75.2651 134.91 75.2347 139.035 77.6562 139.035C80.0473 139.035 80.1601 135.707 80.1601 133.679C80.1601 132.345 80.1037 130.75 79.7001 129.485C79.3529 128.384 78.6629 127.955 77.6822 127.955Z",
    fill: "#221F1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6488 141.965H87.5764C87.2683 141.943 87.0209 141.696 87.0209 141.393L87.0166 125.576C87.0426 125.286 87.2987 125.06 87.6111 125.06H90.4709C90.7399 125.073 90.9612 125.255 91.022 125.502V127.92H91.0784C91.942 125.758 93.1527 124.727 95.2834 124.727C96.6677 124.727 98.0173 125.225 98.8853 126.59C99.6924 127.855 99.6924 129.983 99.6924 131.513V141.466C99.6577 141.744 99.4017 141.965 99.0979 141.965H96.0038C95.7217 141.943 95.4874 141.735 95.457 141.466V132.878C95.457 131.149 95.6566 128.618 93.5259 128.618C92.7752 128.618 92.0852 129.121 91.7424 129.883C91.3084 130.85 91.252 131.812 91.252 132.878V141.393C91.2477 141.709 90.9786 141.965 90.6488 141.965Z",
    fill: "#221F1F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5401 134.412V133.745C47.3095 133.745 44.9532 134.221 44.9532 136.847C44.9532 138.178 45.6432 139.079 46.8279 139.079C47.6958 139.079 48.4725 138.546 48.9629 137.679C49.5704 136.613 49.5401 135.612 49.5401 134.412ZM52.6515 141.922C52.4476 142.104 52.1525 142.117 51.9225 141.995C50.8984 141.146 50.7161 140.752 50.1519 139.941C48.4595 141.666 47.2618 142.182 45.066 142.182C42.471 142.182 40.4487 140.583 40.4487 137.38C40.4487 134.88 41.807 133.177 43.7381 132.345C45.4132 131.608 47.7522 131.478 49.5401 131.275V130.876C49.5401 130.144 49.5965 129.277 49.1669 128.644C48.7893 128.077 48.069 127.843 47.4354 127.843C46.2594 127.843 45.2092 128.445 44.9532 129.693C44.9011 129.97 44.6971 130.243 44.4194 130.256L41.4251 129.936C41.1734 129.879 40.8957 129.676 40.9651 129.29C41.6551 125.667 44.9315 124.575 47.865 124.575C49.3665 124.575 51.328 124.974 52.5127 126.109C54.0141 127.509 53.8709 129.377 53.8709 131.409V136.21C53.8709 137.653 54.4698 138.286 55.0339 139.066C55.2336 139.343 55.2769 139.677 55.0253 139.885C54.396 140.409 53.2764 141.384 52.6602 141.93L52.6515 141.922Z",
    fill: "#221F1F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09134 134.412V133.745C6.86082 133.745 4.50445 134.221 4.50445 136.847C4.50445 138.178 5.19443 139.079 6.37913 139.079C7.24704 139.079 8.02381 138.546 8.51418 137.679C9.12172 136.613 9.09134 135.612 9.09134 134.412ZM12.2028 141.922C11.9988 142.104 11.7037 142.117 11.4738 141.995C10.4496 141.146 10.2674 140.752 9.70322 139.941C8.01079 141.666 6.81308 142.182 4.61727 142.182C2.02222 142.182 0 140.583 0 137.38C0 134.88 1.35828 133.177 3.28937 132.345C4.96444 131.608 7.30345 131.478 9.09134 131.275V130.876C9.09134 130.144 9.14776 129.277 8.71814 128.644C8.3406 128.077 7.62024 127.843 6.98666 127.843C5.81065 127.843 4.76048 128.445 4.50445 129.693C4.45237 129.97 4.24841 130.243 3.97068 130.256L0.976397 129.936C0.724703 129.879 0.446972 129.676 0.516405 129.29C1.20639 125.667 4.48275 124.575 7.41628 124.575C8.91776 124.575 10.8792 124.974 12.0639 126.109C13.5654 127.509 13.4222 129.377 13.4222 131.409V136.21C13.4222 137.653 14.0211 138.286 14.5852 139.066C14.7848 139.343 14.8282 139.677 14.5765 139.885C13.9473 140.409 12.8277 141.384 12.2115 141.93L12.2028 141.922Z",
    fill: "#221F1F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M225.81 83.38C218.155 83.38 210.527 83.38 202.899 83.38C202.897 83.3681 202.893 83.3562 202.891 83.344C202.968 83.3086 203.043 83.2698 203.121 83.2388C212.492 79.5386 221.862 75.8391 231.233 72.1396C232.653 71.5788 234.074 71.0183 235.496 70.4615C235.634 70.4071 235.736 70.329 235.818 70.2021C236.281 69.479 236.693 68.7293 236.985 67.9182C237.142 67.4803 237.269 67.0317 237.291 66.5637C237.302 66.3511 237.294 66.1333 237.262 65.9231C237.18 65.3809 236.864 65.0227 236.363 64.8192C235.887 64.6265 235.389 64.5416 234.882 64.5079C234.173 64.4607 233.462 64.4615 232.753 64.5376C232.701 64.5432 232.648 64.5384 232.591 64.5384C232.282 64.0521 231.823 63.7503 231.333 63.4893C230.477 63.0348 229.554 62.7738 228.615 62.5663C221.558 61.0055 214.5 59.4475 207.442 57.8883C207.358 57.8697 207.274 57.8471 207.194 57.7939C218.975 57.7939 230.756 57.7939 242.571 57.7939C240.702 66.3257 238.836 74.8443 236.967 83.3796C233.244 83.38 229.54 83.38 225.81 83.38Z",
    fill: "#4060AA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M209.528 78.7548C206.442 80.2914 203.373 81.8177 200.267 83.3626C201.69 76.7209 203.106 70.114 204.522 63.5032C204.586 63.4981 204.629 63.4921 204.672 63.4921C208.768 63.4794 212.865 63.4536 216.961 63.46C219.112 63.4635 221.262 63.5155 223.412 63.5603C224.727 63.5877 226.036 63.7107 227.339 63.8943C228.042 63.9935 228.747 64.0811 229.449 64.1898C229.888 64.258 230.318 64.377 230.723 64.5658C231.121 64.7514 231.464 65.0077 231.728 65.4067C226.451 65.4067 221.204 65.4067 215.912 65.4067C216.721 67.8881 217.527 70.3401 218.335 72.8159C218.439 72.7727 218.526 72.7386 218.612 72.7005C221.363 71.4717 224.164 70.379 227.055 69.5266C228.299 69.1597 229.559 68.8563 230.843 68.6671C231.786 68.5282 232.733 68.46 233.684 68.5893C233.85 68.6119 234.016 68.6488 234.177 68.6952C234.314 68.7341 234.441 68.7999 234.517 68.9384C234.456 69.1069 234.308 69.0903 234.183 69.1069C233.805 69.1581 233.423 69.1887 233.047 69.2537C231.443 69.5321 229.874 69.9514 228.32 70.4349C225.175 71.4134 222.132 72.6497 219.164 74.0749C215.951 75.6178 212.751 77.1873 209.528 78.7548Z",
    fill: "#4060AA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M231.302 91.2727C220.34 91.2727 209.405 91.2727 198.456 91.2727C198.462 91.176 198.466 91.1077 198.471 91.0225C213.189 91.0225 227.897 91.0225 242.62 91.0225C242.609 91.1065 242.599 91.1823 242.587 91.2727C238.826 91.2727 235.077 91.2727 231.302 91.2727Z",
    fill: "#FF2A0C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M204.068 86.4727C204.359 86.4727 204.624 86.4727 204.912 86.4727C205.215 87.4171 205.516 88.3559 205.817 89.2951C205.835 89.2948 205.854 89.2948 205.872 89.2944C206.075 88.3603 206.278 87.4262 206.482 86.485C206.765 86.485 207.028 86.485 207.33 86.485C207.044 87.8498 206.762 89.2 206.476 90.5648C206.1 90.5648 205.731 90.5648 205.33 90.5648C205.007 89.664 204.677 88.745 204.346 87.8256C204.327 87.8252 204.308 87.8248 204.288 87.8244C204.09 88.7367 203.926 89.6565 203.732 90.5696C203.432 90.5696 203.15 90.5696 202.855 90.5696C203.143 89.2015 203.426 87.8486 203.715 86.4727C203.834 86.4727 203.939 86.4727 204.068 86.4727Z",
    fill: "#4060AA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M220.047 87.483C220.239 88.5956 219.669 89.8093 218.748 90.2757C218.369 90.4677 217.965 90.5665 217.543 90.5736C216.965 90.5835 216.388 90.58 215.81 90.5812C215.785 90.5812 215.76 90.5697 215.716 90.5593C215.995 89.2032 216.273 87.8499 216.55 86.5005C217.381 86.4605 218.197 86.4263 219.007 86.5513C219.538 86.6326 219.898 86.9265 220.047 87.483ZM217.685 87.1816C217.581 87.1816 217.477 87.1816 217.36 87.1816C217.166 88.0903 216.978 88.9748 216.786 89.8732C217.183 89.8823 217.556 89.912 217.92 89.8081C218.702 89.5848 219.266 88.6793 219.136 87.8693C219.068 87.4517 218.805 87.2109 218.375 87.1875C218.162 87.176 217.949 87.1831 217.685 87.1816Z",
    fill: "#4060AA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M202.448 95.7971C202.385 95.7765 202.343 95.7634 202.302 95.7471C201.443 95.4064 201.074 94.7853 201.232 93.8659C201.373 93.0468 201.756 92.3622 202.504 91.9529C203.143 91.6034 203.832 91.5094 204.541 91.6978C205.201 91.8731 205.608 92.3908 205.658 93.0714C205.69 93.5156 205.632 93.948 205.465 94.3585C205.126 95.1899 204.472 95.6357 203.627 95.8308C203.24 95.9201 202.852 95.9213 202.448 95.7971ZM202.513 93.0294C202.402 93.2999 202.251 93.5613 202.188 93.8425C201.979 94.7742 202.602 95.3695 203.518 95.1359C203.56 95.1252 203.601 95.1078 203.643 95.0931C204.408 94.8257 204.95 93.6656 204.667 92.8993C204.549 92.5804 204.326 92.3805 203.989 92.3305C203.364 92.2377 202.882 92.4705 202.513 93.0294Z",
    fill: "#4060AA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M231.942 66.8029C230.789 66.8322 229.661 66.862 228.534 66.8889C228.38 66.8925 228.216 66.9183 228.085 66.7914C228.151 66.6541 228.275 66.6668 228.387 66.6513C228.887 66.5815 229.392 66.5316 229.887 66.4356C230.26 66.3634 230.626 66.2476 230.985 66.1238C231.359 65.9953 231.7 65.8037 231.921 65.417C232.831 65.4305 233.745 65.4352 234.658 65.463C234.975 65.4725 235.299 65.5054 235.603 65.5868C236.24 65.7569 236.519 66.2662 236.344 66.906C236.266 67.1884 236.157 67.4656 236.033 67.7314C235.787 68.2557 235.523 68.7718 235.26 69.2878C235.191 69.4223 235.098 69.544 234.874 69.5115C234.9 69.4104 234.916 69.3199 234.946 69.2351C235.109 68.7821 235.28 68.3323 235.437 67.8774C235.497 67.7012 235.542 67.5164 235.568 67.332C235.612 67.0103 235.502 66.8631 235.189 66.7981C235.094 66.7783 234.996 66.7676 234.899 66.7683C233.922 66.7779 232.945 66.7906 231.942 66.8029Z",
    fill: "#4060AA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M230.01 93.2401C229.776 93.678 229.412 93.9124 228.958 94.0306C229.162 94.6137 229.362 95.1845 229.568 95.7763C229.207 95.7763 228.873 95.7763 228.52 95.7763C228.295 95.0492 228.069 94.3182 227.836 93.5646C227.979 93.5551 228.1 93.5499 228.22 93.5388C228.535 93.5099 228.806 93.3869 229.004 93.1362C229.109 93.0037 229.195 92.8558 229.124 92.6686C229.051 92.4742 228.899 92.3961 228.71 92.3901C228.445 92.3814 228.18 92.3882 227.886 92.3882C227.644 93.517 227.402 94.6482 227.159 95.781C226.846 95.781 226.555 95.781 226.232 95.781C226.512 94.4154 226.788 93.0656 227.068 91.7028C227.145 91.6972 227.213 91.6877 227.282 91.6877C227.797 91.6865 228.313 91.6798 228.828 91.6909C229.039 91.6952 229.258 91.7103 229.458 91.7718C230.016 91.9439 230.271 92.4595 230.098 93.0244C230.077 93.091 230.046 93.1557 230.01 93.2401Z",
    fill: "#4060AA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M201.748 88.5691C201.9 87.8591 202.046 87.171 202.192 86.4844C202.508 86.4844 202.799 86.4844 203.106 86.4844C203.096 86.5665 203.092 86.6359 203.078 86.7029C202.89 87.6037 202.698 88.5037 202.513 89.4048C202.449 89.7178 202.296 89.9776 202.044 90.1604C201.293 90.7054 200.468 90.8339 199.596 90.5154C199.05 90.3155 198.787 89.857 198.896 89.2823C199.072 88.3529 199.28 87.4296 199.477 86.4895C199.792 86.4895 200.096 86.4895 200.424 86.4895C200.325 86.9683 200.232 87.43 200.136 87.8909C200.06 88.2582 199.975 88.6235 199.907 88.9919C199.88 89.1395 199.874 89.2954 199.886 89.4453C199.911 89.7602 200.129 89.9645 200.443 89.9891C200.977 90.0307 201.505 89.6428 201.63 89.1141C201.671 88.9408 201.705 88.7655 201.748 88.5691Z",
    fill: "#4060AA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M214.936 94.2691C215.014 94.7776 215.091 95.2627 215.166 95.7466C214.971 95.801 213.01 95.8196 212.48 95.7712C212.619 95.5412 212.75 95.3238 212.893 95.0878C213.292 95.0878 213.698 95.0878 214.136 95.0878C214.018 94.2926 213.904 93.5223 213.792 92.7611C213.768 92.7496 213.76 92.7429 213.753 92.7433C213.745 92.7437 213.734 92.7492 213.73 92.756C213.155 93.7614 212.581 94.7669 212.003 95.7788C211.707 95.7788 211.416 95.7788 211.103 95.7788C211.127 95.7193 211.142 95.6633 211.17 95.615C211.891 94.3628 212.616 93.1129 213.332 91.8576C213.41 91.7191 213.498 91.6759 213.647 91.6811C213.938 91.6914 214.23 91.6838 214.534 91.6838C214.669 92.5545 214.801 93.4001 214.936 94.2691Z",
    fill: "#4060AA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M227.341 89.3797C227.869 88.4666 228.389 87.573 228.898 86.6722C228.985 86.5176 229.079 86.4592 229.254 86.4688C229.536 86.4838 229.82 86.4727 230.112 86.4727C230.325 87.8443 230.534 89.1925 230.747 90.5621C229.855 90.5621 228.973 90.5621 228.059 90.5621C228.2 90.3293 228.336 90.1052 228.475 89.8763C228.885 89.8763 229.284 89.8763 229.717 89.8763C229.6 89.0902 229.486 88.3223 229.372 87.5548C229.351 87.5492 229.33 87.5441 229.309 87.5385C228.735 88.5472 228.161 89.5554 227.583 90.5704C227.282 90.5704 226.985 90.5704 226.655 90.5704C226.889 90.1639 227.11 89.7803 227.341 89.3797Z",
    fill: "#4060AA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M213.749 87.9458C213.734 88.0287 213.723 88.0889 213.707 88.1746C214.304 88.1746 214.886 88.1746 215.505 88.1746C215.456 88.4003 215.413 88.5962 215.365 88.8136C214.762 88.8136 214.171 88.8136 213.567 88.8136C213.494 89.1642 213.426 89.4938 213.351 89.8544C214.035 89.8544 214.696 89.8544 215.399 89.8544C215.346 90.111 215.3 90.3331 215.251 90.5683C214.253 90.5683 213.263 90.5683 212.25 90.5683C212.537 89.2007 212.821 87.843 213.105 86.4873C214.124 86.4873 215.113 86.4873 216.133 86.4873C216.079 86.7122 216.029 86.9177 215.973 87.1477C215.294 87.1477 214.615 87.1477 213.916 87.1477C213.859 87.4202 213.806 87.6717 213.749 87.9458Z",
    fill: "#4060AA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M233.968 90.3541C234.239 89.0567 234.506 87.7815 234.776 86.4912C235.783 86.4912 236.781 86.4912 237.807 86.4912C237.751 86.7181 237.698 86.9307 237.642 87.1596C236.956 87.1596 236.283 87.1596 235.587 87.1596C235.517 87.4935 235.449 87.8132 235.375 88.165C235.977 88.165 236.557 88.165 237.174 88.165C237.128 88.3947 237.088 88.5902 237.045 88.8072C236.447 88.8072 235.854 88.8072 235.243 88.8072C235.168 89.161 235.098 89.4966 235.02 89.8631C235.717 89.8631 236.379 89.8631 237.07 89.8631C237.018 90.1161 236.972 90.339 236.924 90.5711C235.919 90.5711 234.927 90.5711 233.928 90.5711C233.942 90.4977 233.953 90.437 233.968 90.3541Z",
    fill: "#4060AA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M225.223 95.072C225.47 95.072 225.691 95.072 225.947 95.072C225.899 95.3164 225.855 95.5385 225.809 95.7745C224.81 95.7745 223.82 95.7745 222.803 95.7745C223.089 94.4116 223.371 93.0611 223.656 91.7002C224.661 91.7002 225.652 91.7002 226.68 91.7002C226.629 91.9176 226.58 92.129 226.526 92.3594C225.847 92.3594 225.176 92.3594 224.473 92.3594C224.4 92.7001 224.33 93.0262 224.254 93.3812C224.862 93.3812 225.445 93.3812 226.055 93.3812C226.007 93.6076 225.966 93.8056 225.921 94.0221C225.315 94.0221 224.723 94.0221 224.121 94.0221C224.048 94.37 223.979 94.6984 223.901 95.0716C224.354 95.072 224.775 95.072 225.223 95.072Z",
    fill: "#4060AA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M240.849 92.3673C240.638 92.3673 240.453 92.3673 240.249 92.3673C240.178 92.7049 240.111 93.0258 240.038 93.374C240.639 93.374 241.221 93.374 241.84 93.374C241.793 93.5997 241.753 93.7945 241.707 94.0114C241.107 94.0114 240.517 94.0114 239.906 94.0114C239.831 94.3652 239.761 94.7 239.684 95.0661C240.378 95.0661 241.04 95.0661 241.734 95.0661C241.682 95.3191 241.637 95.5413 241.589 95.7757C240.591 95.7757 239.601 95.7757 238.586 95.7757C238.871 94.412 239.153 93.0615 239.437 91.7002C240.441 91.7002 241.432 91.7002 242.441 91.7002C242.449 91.9223 242.353 92.1234 242.31 92.3673C241.829 92.3673 241.352 92.3673 240.849 92.3673Z",
    fill: "#4060AA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M197.927 95.7913C197.778 95.7913 197.655 95.7913 197.501 95.7913C197.783 94.4178 198.061 93.0688 198.34 91.7075C198.408 91.7008 198.467 91.6893 198.526 91.6893C199.076 91.6881 199.627 91.6885 200.177 91.6889C200.222 91.6889 200.266 91.6909 200.31 91.692C201.093 91.7119 201.392 92.3628 201.253 92.9649C201.101 93.6257 200.662 94.006 200.028 94.1667C199.719 94.2448 199.4 94.29 199.066 94.135C199.05 93.97 199.033 93.795 199.012 93.5908C199.198 93.5908 199.372 93.588 199.546 93.5912C199.901 93.5983 200.133 93.4071 200.278 93.1065C200.329 93.0014 200.34 92.8661 200.334 92.7463C200.324 92.5563 200.21 92.4393 200.021 92.3993C199.74 92.3406 199.459 92.3318 199.152 92.3671C198.913 93.5007 198.675 94.6327 198.431 95.7909C198.268 95.7913 198.11 95.7913 197.927 95.7913Z",
    fill: "#4060AA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M231.003 95.7904C230.846 95.8015 230.846 95.7024 230.833 95.6143C230.763 95.1645 230.693 94.7143 230.624 94.2645C230.498 93.4443 230.371 92.6236 230.246 91.803C230.242 91.7776 230.246 91.751 230.246 91.7062C230.539 91.7062 230.827 91.7062 231.146 91.7062C231.297 92.7113 231.451 93.7299 231.614 94.8143C231.695 94.6735 231.744 94.5922 231.79 94.5085C232.262 93.6386 232.737 92.7704 233.202 91.8962C233.283 91.7435 233.366 91.6665 233.548 91.6828C233.767 91.7022 233.989 91.6876 234.264 91.6876C233.474 93.073 232.706 94.4224 231.926 95.7908C231.627 95.7904 231.327 95.7904 231.003 95.7904Z",
    fill: "#4060AA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M206.827 95.7907C206.331 95.7907 205.862 95.7907 205.363 95.7907C205.412 95.5503 205.455 95.3349 205.502 95.1045C205.573 95.0985 205.641 95.0882 205.709 95.0878C206.091 95.0863 206.473 95.087 206.855 95.087C206.917 95.087 206.98 95.089 207.042 95.0855C207.228 95.074 207.363 94.9851 207.426 94.8058C207.486 94.6325 207.427 94.4925 207.292 94.3767C207.009 94.1323 206.722 93.8916 206.446 93.6393C206.322 93.5263 206.201 93.4017 206.11 93.2621C205.815 92.8099 205.927 92.303 206.376 92.0016C206.625 91.8342 206.906 91.735 207.199 91.7204C207.74 91.6926 208.282 91.6981 208.823 91.6914C208.837 91.6914 208.851 91.7097 208.881 91.7311C208.837 91.9393 208.791 92.1551 208.74 92.3943C208.397 92.3943 208.062 92.3939 207.727 92.3943C207.602 92.3946 207.477 92.3891 207.354 92.4002C207.2 92.4141 207.091 92.4998 207.033 92.6465C206.973 92.8008 207.026 92.9182 207.142 93.0277C207.479 93.3454 207.812 93.6675 208.144 93.9911C208.43 94.27 208.53 94.6063 208.418 94.9942C208.322 95.3294 208.082 95.5329 207.77 95.6574C207.476 95.7752 207.166 95.7927 206.827 95.7907Z",
    fill: "#4060AA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M239.284 89.6756C239.386 89.4539 239.323 89.2956 239.162 89.1584C238.885 88.9212 238.607 88.6844 238.338 88.4377C238.214 88.3242 238.093 88.2001 238.002 88.0601C237.704 87.602 237.827 87.0764 238.288 86.7825C238.533 86.6266 238.806 86.5318 239.089 86.5156C239.637 86.4842 240.187 86.4834 240.784 86.4688C240.728 86.7266 240.68 86.9471 240.628 87.1879C240.244 87.1879 239.873 87.1871 239.502 87.1887C239.405 87.1891 239.306 87.1879 239.21 87.2037C239.056 87.2287 238.961 87.3263 238.911 87.4754C238.864 87.6154 238.918 87.715 239.015 87.8082C239.35 88.1283 239.682 88.452 240.017 88.7716C240.25 88.9942 240.371 89.2619 240.343 89.5867C240.309 89.9913 240.088 90.2666 239.726 90.4229C239.573 90.4891 239.405 90.5534 239.242 90.5569C238.586 90.572 237.931 90.5633 237.255 90.5633C237.302 90.3431 237.348 90.1266 237.399 89.8826C237.581 89.8826 237.765 89.8826 237.95 89.8826C238.252 89.8826 238.554 89.8787 238.856 89.8842C239.028 89.8874 239.172 89.8446 239.284 89.6756Z",
    fill: "#4060AA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M221.575 87.2437C221.722 86.891 221.998 86.7086 222.322 86.6217C222.611 86.5444 222.914 86.5075 223.213 86.4896C223.585 86.4674 223.959 86.4825 224.332 86.4829C224.365 86.4829 224.398 86.4944 224.452 86.5047C224.404 86.7316 224.358 86.947 224.306 87.1881C223.939 87.1881 223.578 87.1873 223.216 87.1885C223.109 87.1889 223.002 87.1881 222.897 87.202C222.742 87.2222 222.643 87.3182 222.591 87.4658C222.54 87.6137 222.598 87.7212 222.704 87.822C223.034 88.1345 223.36 88.4514 223.687 88.7668C223.831 88.9048 223.946 89.0599 223.994 89.259C224.113 89.7504 223.891 90.2101 223.411 90.4196C223.242 90.4933 223.055 90.5572 222.874 90.562C222.237 90.579 221.598 90.5687 220.935 90.5687C220.98 90.3458 221.024 90.1304 221.072 89.8996C221.141 89.894 221.208 89.8837 221.276 89.8833C221.703 89.8817 222.129 89.8797 222.556 89.8837C222.753 89.8857 222.902 89.8127 222.983 89.6275C223.055 89.4605 223.008 89.3121 222.833 89.1571C222.574 88.9262 222.309 88.7009 222.049 88.4709C221.962 88.3943 221.877 88.3154 221.8 88.2285C221.556 87.9489 221.451 87.632 221.575 87.2437Z",
    fill: "#4060AA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M219.691 95.196C219.724 95.0596 219.816 95.0885 219.891 95.0881C220.291 95.0861 220.69 95.0873 221.09 95.0869C221.161 95.0869 221.233 95.0901 221.302 95.0794C221.465 95.0548 221.579 94.9604 221.634 94.8045C221.69 94.6427 221.641 94.5035 221.517 94.394C221.23 94.141 220.934 93.897 220.653 93.638C220.523 93.519 220.397 93.3861 220.304 93.2374C220.03 92.7983 220.139 92.3132 220.563 92.0154C220.817 91.8365 221.106 91.7329 221.408 91.7207C221.957 91.6988 222.507 91.7143 223.089 91.7143C223.044 91.9285 222.996 92.1494 222.943 92.3941C222.551 92.3941 222.171 92.3938 221.792 92.3945C221.704 92.3949 221.613 92.3902 221.527 92.4053C221.374 92.4322 221.273 92.5302 221.229 92.6789C221.191 92.811 221.231 92.9193 221.333 93.0153C221.67 93.3334 222.002 93.6563 222.336 93.9775C222.641 94.271 222.737 94.6225 222.61 95.0282C222.519 95.3202 222.311 95.5117 222.038 95.6272C221.892 95.689 221.734 95.7541 221.58 95.7573C220.916 95.7715 220.252 95.7632 219.572 95.7632C219.61 95.5819 219.648 95.4003 219.691 95.196Z",
    fill: "#4060AA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M237.823 95.8568C237.454 95.8544 237.104 95.8786 236.763 95.839C235.545 95.6978 235.091 94.7863 235.278 93.7653C235.511 92.4937 236.508 91.6604 237.809 91.6088C238.209 91.5929 238.604 91.6322 239.004 91.7607C238.967 91.9884 238.931 92.2053 238.896 92.4239C238.632 92.3878 238.388 92.3509 238.142 92.3231C238.037 92.3112 237.93 92.3112 237.824 92.318C237.413 92.3446 237.032 92.4505 236.762 92.7924C236.422 93.2239 236.192 93.7007 236.238 94.2707C236.276 94.747 236.561 95.052 237.035 95.1464C237.408 95.2206 237.778 95.1762 238.147 95.1147C238.222 95.102 238.297 95.0826 238.408 95.0584C238.347 95.2892 238.299 95.4947 238.235 95.695C238.22 95.7426 238.159 95.7914 238.109 95.8084C238.025 95.837 237.934 95.8402 237.823 95.8568Z",
    fill: "#4060AA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M232.337 90.3452C232.318 90.4281 232.305 90.4888 232.288 90.5657C231.982 90.5657 231.676 90.5657 231.342 90.5657C231.577 89.4448 231.81 88.3314 232.049 87.1855C231.628 87.1855 231.224 87.1855 230.79 87.1855C230.843 86.9361 230.889 86.7211 230.938 86.4902C232.095 86.4902 233.243 86.4902 234.419 86.4902C234.36 86.7235 234.303 86.944 234.243 87.1776C233.828 87.1776 233.431 87.1776 233.004 87.1776C232.782 88.2339 232.562 89.2786 232.337 90.3452Z",
    fill: "#4060AA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M210.899 89.1648C210.799 89.6411 210.704 90.0957 210.606 90.5661C210.297 90.5661 209.991 90.5661 209.658 90.5661C209.892 89.448 210.124 88.3354 210.364 87.1883C209.942 87.1883 209.539 87.1883 209.107 87.1883C209.161 86.9365 209.207 86.7211 209.256 86.4902C210.413 86.4902 211.563 86.4902 212.742 86.4902C212.679 86.7246 212.62 86.9436 212.556 87.184C212.138 87.184 211.733 87.184 211.318 87.184C211.177 87.8519 211.041 88.4976 210.899 89.1648Z",
    fill: "#4060AA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M225.77 87.6865C225.805 87.5167 225.836 87.3692 225.874 87.1871C225.453 87.1871 225.051 87.1871 224.617 87.1871C224.67 86.9353 224.716 86.7203 224.765 86.4902C225.923 86.4902 227.071 86.4902 228.248 86.4902C228.185 86.7282 228.127 86.9476 228.066 87.1792C227.648 87.1792 227.251 87.1792 226.827 87.1792C226.588 88.314 226.352 89.4365 226.113 90.5705C225.803 90.5705 225.496 90.5705 225.17 90.5705C225.37 89.6078 225.567 88.6583 225.77 87.6865Z",
    fill: "#4060AA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M211.467 91.6865C211.874 91.6865 212.254 91.6865 212.668 91.6865C212.602 91.9356 212.544 92.155 212.484 92.3862C212.067 92.3862 211.67 92.3862 211.244 92.3862C211.005 93.519 210.768 94.6415 210.529 95.7759C210.22 95.7759 209.922 95.7759 209.585 95.7759C209.819 94.6566 210.05 93.5456 210.289 92.4001C209.875 92.4001 209.474 92.4001 209.033 92.4001C209.087 92.1474 209.132 91.9336 209.184 91.6869C209.938 91.6865 210.69 91.6865 211.467 91.6865Z",
    fill: "#4060AA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M216.601 94.6833C216.572 94.8273 216.55 94.9494 216.521 95.1005C217.117 95.1005 217.698 95.1005 218.32 95.1005C218.272 95.3476 218.23 95.561 218.187 95.7788C217.261 95.7788 216.349 95.7788 215.414 95.7788C215.695 94.4124 215.973 93.0622 216.252 91.7041C216.576 91.7041 216.884 91.7041 217.226 91.7041C217.018 92.6997 216.812 93.6806 216.601 94.6833Z",
    fill: "#4060AA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M208.64 87.5305C208.426 88.5566 208.215 89.5605 208.004 90.5688C207.683 90.5688 207.375 90.5688 207.056 90.5688C207.343 89.2004 207.627 87.8474 207.913 86.4854C208.226 86.4854 208.526 86.4854 208.858 86.4854C208.785 86.8348 208.714 87.1715 208.64 87.5305Z",
    fill: "#4060AA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M234.298 92.5754C234.363 92.2747 234.423 91.9963 234.489 91.6865C234.64 91.6865 234.788 91.6865 234.935 91.6865C235.086 91.6865 235.236 91.6865 235.43 91.6865C235.144 93.0569 234.863 94.4059 234.578 95.7719C234.268 95.7719 233.962 95.7719 233.634 95.7719C233.855 94.7077 234.075 93.6527 234.298 92.5754Z",
    fill: "#4060AA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M243.199 95.5732C243.135 95.6486 243.131 95.7799 242.97 95.8084C242.948 95.6811 242.927 95.5617 242.901 95.409C242.852 95.5578 242.812 95.6787 242.756 95.8465C242.714 95.6732 242.778 95.2032 242.834 95.1373C242.85 95.1195 242.89 95.0992 242.902 95.1068C242.935 95.127 242.977 95.1579 242.984 95.1913C243.01 95.3107 243.023 95.4324 243.044 95.5752C243.227 95.4459 243.208 95.1655 243.44 95.0977C243.476 95.3376 243.406 95.6454 243.247 95.8398C243.262 95.7259 243.27 95.6645 243.288 95.5689C243.298 95.4923 243.298 95.4499 243.306 95.4031C243.318 95.3864 243.321 95.3737 243.324 95.3614C243.316 95.3777 243.308 95.3939 243.285 95.4166C243.247 95.4729 243.223 95.5233 243.199 95.5732Z",
    fill: "#4060AA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M242.523 95.0986C242.583 95.1113 242.621 95.124 242.719 95.1569C242.589 95.1926 242.519 95.2117 242.436 95.2343C242.389 95.4195 242.341 95.6119 242.293 95.8043C242.271 95.8007 242.25 95.7971 242.229 95.7935C242.176 95.6119 242.298 95.4374 242.284 95.2375C242.262 95.2295 242.233 95.2184 242.204 95.2089C242.173 95.1986 242.142 95.1899 242.052 95.1617C242.114 95.132 242.136 95.1133 242.159 95.1121C242.273 95.105 242.387 95.1026 242.523 95.0986Z",
    fill: "#4060AA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M243.298 95.4082C243.298 95.4506 243.299 95.4931 243.292 95.5498C243.271 95.5661 243.256 95.568 243.221 95.572C243.223 95.524 243.246 95.4736 243.285 95.4165C243.3 95.4094 243.298 95.4082 243.298 95.4082Z",
    fill: "#4060AA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M243.3 95.4103C243.309 95.3948 243.316 95.3786 243.324 95.3623C243.322 95.3746 243.318 95.3873 243.307 95.404C243.298 95.4083 243.3 95.4095 243.3 95.4103Z",
    fill: "#4060AA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M173.954 135.296C173.641 136.624 173.324 137.912 173.038 139.207C172.98 139.469 172.863 139.594 172.621 139.633C171.649 139.79 170.682 139.971 169.707 140.094C169.024 140.18 168.33 140.202 167.638 140.23C165.247 140.325 162.944 139.974 160.833 138.771C159.091 137.778 157.814 136.378 157.264 134.406C156.775 132.655 157.005 130.953 157.708 129.305C158.541 127.352 159.894 125.818 161.583 124.574C163.772 122.962 166.227 122.013 168.919 121.662C171.418 121.336 173.874 121.587 176.299 122.242C176.313 122.245 176.321 122.262 176.379 122.315C176.015 124.546 175.646 126.811 175.263 129.151C175.121 129.045 175.01 128.964 174.902 128.881C174.043 128.211 173.107 127.698 172.032 127.486C170.063 127.096 168.296 127.531 166.769 128.853C166.177 129.363 165.755 129.996 165.574 130.775C165.36 131.695 165.569 132.504 166.21 133.19C166.852 133.876 167.671 134.219 168.58 134.353C170.221 134.596 171.763 134.233 173.232 133.505C173.652 133.299 174.054 133.053 174.529 132.788C174.335 133.645 174.149 134.454 173.954 135.296Z",
    fill: "#E32C38"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M236.698 137.048C235.737 135.389 235.737 133.676 236.282 131.933C236.898 129.964 238.168 128.488 239.837 127.333C241.473 126.201 243.295 125.534 245.251 125.219C247.009 124.935 248.764 124.935 250.509 125.317C252.145 125.674 253.642 126.326 254.825 127.562C256.025 128.817 256.542 130.323 256.37 132.053C256.106 134.736 254.714 136.733 252.556 138.239C251.061 139.283 249.389 139.905 247.609 140.239C245.503 140.633 243.401 140.635 241.312 140.114C240.351 139.874 239.443 139.509 238.607 138.967C237.84 138.471 237.196 137.857 236.698 137.048ZM248.606 130.455C247.395 129.654 245.126 129.802 243.806 131.026C243.345 131.453 242.998 131.958 242.812 132.566C242.356 134.056 243.059 135.319 244.567 135.662C245.695 135.919 246.789 135.785 247.812 135.227C248.645 134.772 249.231 134.095 249.5 133.166C249.814 132.067 249.534 131.177 248.606 130.455Z",
    fill: "#E32C38"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M174.685 132.923C174.693 132.822 174.702 132.722 174.738 132.577C174.771 132.516 174.774 132.499 174.774 132.479C174.782 132.404 174.793 132.331 174.829 132.217C174.857 132.178 174.865 132.136 174.865 132.136C174.868 132.092 174.874 132.047 174.904 131.96C174.943 131.899 174.949 131.88 174.952 131.857C174.957 131.815 174.963 131.771 174.996 131.69C175.032 131.634 175.04 131.617 175.04 131.598C175.221 130.937 175.565 130.357 175.952 129.799C177.007 128.27 178.424 127.171 180.085 126.399C180.81 126.061 181.587 125.835 182.401 125.559C182.487 125.542 182.515 125.526 182.54 125.509C182.593 125.495 182.648 125.481 182.754 125.47C182.834 125.456 182.862 125.439 182.893 125.422C182.951 125.408 183.007 125.394 183.123 125.386C183.232 125.369 183.284 125.347 183.334 125.328C183.415 125.311 183.493 125.294 183.629 125.286C183.715 125.277 183.746 125.258 183.776 125.241C183.884 125.224 183.993 125.208 184.165 125.202C184.284 125.194 184.34 125.171 184.393 125.152C184.559 125.132 184.726 125.113 184.962 125.11C185.143 125.104 185.251 125.082 185.362 125.06C185.954 125.054 186.548 125.051 187.198 125.071C187.356 125.096 187.456 125.093 187.556 125.093C187.606 125.093 187.659 125.093 187.754 125.11C187.798 125.127 187.837 125.13 187.837 125.13C187.904 125.13 187.97 125.13 188.093 125.16C188.209 125.194 188.27 125.199 188.331 125.205C188.44 125.21 188.548 125.216 188.709 125.249C188.792 125.283 188.829 125.288 188.862 125.294C188.942 125.3 189.023 125.305 189.154 125.339C189.234 125.372 189.265 125.378 189.298 125.386C189.44 125.414 189.581 125.442 189.77 125.503C189.87 125.548 189.926 125.556 189.979 125.565C192.176 126.212 193.903 127.408 194.725 129.712C194.731 129.782 194.742 129.799 194.759 129.815C194.809 130 194.859 130.186 194.903 130.429C194.912 130.53 194.925 130.571 194.942 130.613C194.959 130.686 194.975 130.755 194.989 130.903C194.987 131.246 194.987 131.514 194.989 131.779C194.973 133.098 194.553 134.301 193.884 135.416C192.837 137.157 191.309 138.348 189.501 139.196C187.87 139.957 186.151 140.356 184.357 140.473C182.64 140.585 180.948 140.454 179.301 139.929C178.079 139.542 176.971 138.953 176.071 138.016C175.207 137.115 174.688 136.047 174.588 134.725C174.585 134.591 174.574 134.521 174.563 134.451C174.554 134.289 174.543 134.125 174.56 133.899C174.588 133.765 174.588 133.693 174.59 133.62C174.596 133.469 174.604 133.316 174.638 133.112C174.674 133.015 174.679 132.97 174.685 132.923ZM182.032 135.09C182.376 135.383 182.773 135.567 183.209 135.665C184.198 135.882 185.17 135.801 186.098 135.391C187.115 134.942 187.837 134.203 188.137 133.101C188.52 131.695 187.831 130.463 186.429 130.103C185.193 129.785 184.007 129.961 182.921 130.649C182.218 131.096 181.701 131.712 181.451 132.518C181.16 133.458 181.237 134.329 182.032 135.09Z",
    fill: "#E32C38"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M207.378 144.199C207.364 144.286 207.353 144.375 207.314 144.52C207.25 144.768 207.211 144.961 207.172 145.153C207.197 145.162 207.225 145.17 207.25 145.176C207.311 145.019 207.372 144.863 207.431 144.707C207.958 143.706 208.794 143.059 209.819 142.643C211.142 142.107 212.503 141.996 213.875 142.417C214.83 142.71 215.594 143.251 215.941 144.247C216.019 144.467 216.058 144.699 216.139 145.017C216.319 144.068 216.486 143.212 216.658 142.305C217.622 142.255 218.583 142.294 219.597 142.28C219.308 143.817 219.027 145.304 218.738 146.852C219.563 146.852 220.361 146.852 221.197 146.852C221.049 147.619 220.913 148.322 220.78 149.028C218.974 149.028 217.213 149.028 215.391 149.028C215.544 148.188 215.694 147.371 215.847 146.542C215.794 146.551 215.755 146.545 215.75 146.556C215.08 147.856 213.966 148.562 212.603 148.927C211.547 149.209 210.483 149.234 209.419 148.966C208.931 148.844 208.475 148.643 208.067 148.339C207.564 147.965 207.233 147.474 207.092 146.858C207.07 146.768 207.039 146.679 206.939 146.595C206.783 147.396 206.628 148.196 206.467 149.019C205.525 149.019 204.609 149.019 203.648 149.019C203.789 148.249 203.925 147.505 204.07 146.718C203.464 146.718 202.9 146.718 202.292 146.718C202.145 147.474 201.995 148.235 201.842 149.019C200.909 149.019 199.989 149.019 199.02 149.019C199.395 147.022 199.764 145.058 200.137 143.092C200.106 143.078 200.078 143.064 200.048 143.053C198.831 145.039 197.615 147.028 196.395 149.025C195.551 149.025 194.717 149.025 193.829 149.025C193.751 147.834 193.676 146.646 193.595 145.418C193.009 146.648 192.445 147.834 191.879 149.025C191.029 149.025 190.209 149.025 189.346 149.025C188.837 146.807 188.329 144.587 187.818 142.367C188.171 142.269 190.354 142.252 190.845 142.339C190.929 143.625 191.015 144.919 191.104 146.28C191.168 146.191 191.198 146.157 191.218 146.118C191.782 144.919 192.345 143.72 192.906 142.517C192.973 142.372 193.054 142.28 193.234 142.283C193.895 142.292 194.556 142.286 195.273 142.286C195.387 143.591 195.498 144.88 195.617 146.238C195.692 146.127 195.742 146.071 195.773 146.007C196.301 144.841 196.834 143.675 197.351 142.501C197.445 142.286 197.595 142.286 197.776 142.286C199.056 142.289 200.334 142.286 201.614 142.286C202.098 142.286 202.581 142.286 203.117 142.286C202.978 143.045 202.848 143.764 202.711 144.52C203.309 144.52 203.873 144.52 204.486 144.52C204.625 143.809 204.77 143.078 204.917 142.317C205.845 142.317 206.761 142.317 207.736 142.317C207.633 142.869 207.536 143.399 207.414 143.987C207.383 144.093 207.381 144.146 207.378 144.199ZM210.142 146.453C210.547 146.978 211.15 147.142 211.88 146.93C212.542 146.74 213.014 146.213 213.075 145.6C213.128 145.081 212.847 144.629 212.336 144.484C211.653 144.291 211.014 144.409 210.494 144.908C210.078 145.312 209.886 145.806 210.142 146.453Z",
    fill: "#3461AA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M195.023 131.793C194.992 131.52 194.99 131.252 194.99 130.945C195.023 130.831 195.073 130.755 195.087 130.677C195.351 129.28 196.092 128.175 197.173 127.286C198.367 126.307 199.748 125.701 201.242 125.364C203.739 124.798 206.2 124.892 208.603 125.838C208.942 125.972 209.269 126.142 209.661 126.32C208.811 127.609 207.983 128.87 207.133 130.161C206.997 130.089 206.872 130.027 206.75 129.958C205.733 129.383 204.653 129.034 203.478 129.048C203.175 129.051 202.867 129.124 202.572 129.205C202.409 129.249 202.247 129.35 202.122 129.467C201.75 129.813 201.825 130.228 202.311 130.379C202.8 130.529 203.311 130.602 203.811 130.719C204.539 130.889 205.27 131.051 205.989 131.249C206.311 131.338 206.619 131.492 206.917 131.651C208.344 132.423 208.894 133.665 208.544 135.249C208.242 136.61 207.475 137.659 206.386 138.487C205.131 139.444 203.692 139.988 202.159 140.267C199.053 140.833 196.048 140.401 193.126 139.265C193.045 139.235 192.97 139.19 192.845 139.129C193.792 137.72 194.723 136.334 195.681 134.911C195.834 135.015 195.964 135.101 196.092 135.193C197.006 135.837 198 136.292 199.117 136.443C199.748 136.526 200.384 136.54 200.986 136.295C201.209 136.203 201.439 136.061 201.595 135.882C201.881 135.556 201.77 135.146 201.367 134.984C201.125 134.886 200.859 134.844 200.6 134.794C199.678 134.616 198.75 134.465 197.837 134.262C197.245 134.13 196.706 133.849 196.22 133.481C195.712 133.098 195.334 132.621 195.156 131.999C195.128 131.927 195.087 131.866 195.023 131.793Z",
    fill: "#E32C39"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M222.707 130.102C222.749 130.066 222.802 130.036 222.832 129.991C224.413 127.693 226.613 126.273 229.246 125.509C231.798 124.767 234.359 124.906 236.901 125.603C236.926 125.612 236.948 125.637 237.018 125.684C236.726 127.531 236.429 129.405 236.123 131.33C235.937 131.188 235.787 131.076 235.64 130.964C234.684 130.242 233.621 129.81 232.415 129.846C231.146 129.882 230.035 130.334 229.143 131.26C228.737 131.681 228.457 132.175 228.34 132.758C228.179 133.55 228.407 134.219 228.968 134.775C229.571 135.374 230.332 135.628 231.16 135.678C232.59 135.768 233.884 135.344 235.09 134.604C235.215 134.529 235.337 134.454 235.52 134.342C235.473 134.593 235.445 134.791 235.401 134.984C235.054 136.507 234.698 138.027 234.365 139.553C234.301 139.84 234.179 139.99 233.896 140.032C232.968 140.169 232.043 140.361 231.11 140.434C230.19 140.506 229.257 140.509 228.337 140.451C226.974 140.367 225.682 139.977 224.502 139.265C221.963 137.737 220.938 135.073 221.78 132.22C221.985 131.522 222.304 130.878 222.638 130.214C222.624 130.183 222.618 130.186 222.649 130.195C222.691 130.164 222.704 130.128 222.716 130.094C222.71 130.097 222.707 130.102 222.707 130.102Z",
    fill: "#E32C39"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M222.621 130.184C222.541 130.164 222.455 130.131 222.371 130.128C221.313 130.086 220.255 130.047 219.197 130.008C219.138 130.005 219.08 130.016 218.994 130.025C217.963 133.433 216.93 136.847 215.897 140.267C213.686 140.267 211.497 140.267 209.255 140.267C210.289 136.844 211.314 133.45 212.352 130.002C211.103 130.047 209.919 130.089 208.658 130.133C209.153 128.49 209.633 126.892 210.122 125.274C214.763 125.274 219.391 125.274 224.08 125.274C223.602 126.884 223.135 128.46 222.688 130.066C222.707 130.097 222.71 130.094 222.682 130.083C222.641 130.111 222.63 130.147 222.619 130.186C222.616 130.189 222.619 130.186 222.621 130.184Z",
    fill: "#E32C39"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M246.879 147.722C246.79 148.177 246.704 148.595 246.617 149.028C243.865 149.028 241.134 149.028 238.379 149.028C238.332 148.754 238.29 148.498 238.243 148.216C237.515 148.216 236.799 148.216 236.054 148.216C235.924 148.473 235.785 148.749 235.643 149.031C234.638 149.031 233.64 149.031 232.615 149.031C232.657 148.704 232.929 148.501 233.043 148.118C232.418 148.565 231.799 148.863 231.113 149.011C230.429 149.159 229.741 149.209 229.055 149.097C228.363 148.983 227.68 148.81 226.949 148.654C226.921 148.729 226.871 148.863 226.813 149.019C225.008 149.019 223.194 149.019 221.327 149.019C221.752 146.774 222.172 144.551 222.597 142.311C224.402 142.311 226.177 142.311 228.005 142.311C227.957 142.911 227.788 143.485 227.691 144.127C226.869 144.127 226.055 144.127 225.227 144.127C225.177 144.364 225.141 144.543 225.091 144.78C225.855 144.78 226.569 144.78 227.343 144.78C227.23 145.393 227.124 145.951 227.016 146.543C226.263 146.543 225.532 146.543 224.78 146.543C224.733 146.757 224.691 146.939 224.635 147.181C225.502 147.181 226.327 147.181 227.18 147.181C227.124 147.536 227.08 147.834 227.032 148.132C227.055 148.144 227.077 148.152 227.099 148.163C227.441 147.658 227.782 147.153 228.132 146.637C228.288 146.738 228.407 146.819 228.532 146.894C228.941 147.142 229.377 147.312 229.86 147.318C230.049 147.321 230.243 147.304 230.427 147.257C230.616 147.209 230.804 147.103 230.785 146.872C230.766 146.651 230.557 146.623 230.388 146.59C230.027 146.523 229.654 146.498 229.304 146.392C228.971 146.291 228.635 146.155 228.352 145.957C227.916 145.653 227.774 145.198 227.882 144.668C228.03 143.946 228.449 143.413 229.041 143.009C229.988 142.364 231.054 142.13 232.182 142.186C232.771 142.216 233.351 142.32 233.893 142.573C234.024 142.635 234.149 142.702 234.301 142.777C233.921 143.366 233.563 143.918 233.213 144.456C232.832 144.314 232.496 144.163 232.146 144.068C231.91 144.004 231.652 144.007 231.404 144.013C231.279 144.015 231.143 144.071 231.038 144.141C230.966 144.191 230.896 144.314 230.907 144.395C230.918 144.473 231.024 144.573 231.104 144.596C231.415 144.679 231.738 144.724 232.052 144.805C232.335 144.877 232.624 144.947 232.89 145.061C233.61 145.368 233.868 145.801 233.84 146.584C233.838 146.643 233.84 146.702 233.84 146.827C233.938 146.699 234.007 146.618 234.063 146.529C234.849 145.232 235.643 143.935 236.415 142.629C236.571 142.364 236.746 142.269 237.046 142.278C237.854 142.297 238.662 142.283 239.473 142.286C239.604 142.286 239.734 142.297 239.884 142.306C240.354 144.275 240.818 146.227 241.284 148.18C241.32 148.18 241.357 148.18 241.39 148.18C241.759 146.236 242.129 144.294 242.507 142.308C243.462 142.261 244.409 142.292 245.415 142.292C245.342 143.078 245.143 143.815 245.02 144.559C244.895 145.312 244.737 146.06 244.584 146.861C245.417 146.861 246.206 146.861 247.034 146.861C246.973 147.167 246.929 147.427 246.879 147.722ZM237.896 146.59C237.99 146.576 238.085 146.562 238.196 146.545C238.16 146.191 238.121 145.87 238.096 145.547C238.071 145.223 238.054 144.9 238.035 144.576C238.004 144.573 237.973 144.571 237.943 144.568C237.646 145.223 237.335 145.876 237.049 146.59C237.351 146.59 237.585 146.59 237.896 146.59Z",
    fill: "#3561AA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M171.072 149.056C166.575 149.056 162.125 149.056 157.653 149.056C157.653 148.462 157.653 147.906 157.653 147.329C167.872 147.329 178.068 147.329 188.276 147.329C188.307 147.407 188.343 147.471 188.359 147.541C188.471 148.029 188.579 148.517 188.698 149.056C182.81 149.056 176.963 149.056 171.072 149.056Z",
    fill: "#3764AB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M162.33 144.128C160.758 144.128 159.23 144.128 157.667 144.128C157.667 143.525 157.667 142.942 157.667 142.337C167.488 142.337 177.304 142.337 187.157 142.337C187.284 142.912 187.412 143.483 187.557 144.128C179.129 144.128 170.752 144.128 162.33 144.128Z",
    fill: "#335FA9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M174.954 144.875C179.232 144.875 183.468 144.875 187.734 144.875C187.865 145.438 187.992 145.98 188.126 146.557C177.954 146.557 167.816 146.557 157.655 146.557C157.655 146.007 157.655 145.469 157.655 144.875C163.419 144.875 169.163 144.875 174.954 144.875Z",
    fill: "#335FA9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M251.306 142.286C252.173 142.286 252.995 142.286 253.87 142.286C253.75 142.919 253.642 143.505 253.523 144.133C252.695 144.133 251.895 144.133 251.07 144.133C251.023 144.353 250.981 144.534 250.931 144.769C251.687 144.769 252.4 144.769 253.181 144.769C253.067 145.379 252.967 145.935 252.856 146.529C252.112 146.529 251.381 146.529 250.617 146.529C250.57 146.757 250.531 146.95 250.481 147.187C251.334 147.187 252.139 147.187 252.989 147.187C252.964 147.826 252.767 148.397 252.692 149.014C250.856 149.014 249.039 149.014 247.165 149.014C247.587 146.78 248.006 144.559 248.437 142.286C249.389 142.286 250.325 142.286 251.306 142.286Z",
    fill: "#3561AA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M254.447 139.609C254.131 140.289 253.531 140.607 252.864 140.471C252.228 140.339 251.975 139.726 252.331 139.187C252.639 138.727 253.323 138.482 253.848 138.644C254.297 138.78 254.478 139.059 254.447 139.609ZM252.836 139.04C252.72 139.201 252.567 139.349 252.495 139.528C252.4 139.765 252.514 139.999 252.728 140.133C253.139 140.39 253.848 140.2 254.075 139.773C254.25 139.441 254.172 139.076 253.859 138.948C253.531 138.814 253.186 138.766 252.898 139.051C252.898 139.048 252.9 139.045 252.836 139.04Z",
    fill: "#E53947"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M156.064 149.737C156.058 149.89 156.053 150.005 156.047 150.122C156.031 150.122 156.017 150.122 156 150.122C156 147.137 156 144.156 156 141.174C156.022 141.174 156.042 141.174 156.064 141.174C156.064 144.013 156.064 146.856 156.064 149.737Z",
    fill: "#EBE9E7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M185.332 125.057C185.257 125.085 185.146 125.107 184.999 125.126C185.076 125.098 185.187 125.076 185.332 125.057Z",
    fill: "#E32C39"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M187.532 125.082C187.462 125.099 187.365 125.099 187.246 125.082C187.318 125.065 187.409 125.065 187.532 125.082Z",
    fill: "#E32C39"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M174.58 133.647C174.591 133.695 174.591 133.767 174.577 133.865C174.566 133.815 174.566 133.745 174.58 133.647Z",
    fill: "#E32C39"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M174.557 134.481C174.577 134.526 174.588 134.596 174.596 134.691C174.579 134.646 174.563 134.576 174.557 134.481Z",
    fill: "#E32C39"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M174.671 132.942C174.68 132.97 174.674 133.015 174.655 133.079C174.646 133.054 174.652 133.007 174.671 132.942Z",
    fill: "#E32C39"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M184.365 125.149C184.34 125.175 184.284 125.194 184.198 125.214C184.223 125.188 184.279 125.166 184.365 125.149Z",
    fill: "#E32C39"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M188.318 125.186C188.279 125.202 188.218 125.197 188.134 125.172C188.17 125.155 188.231 125.161 188.318 125.186Z",
    fill: "#E32C39"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M194.951 130.593C194.931 130.574 194.917 130.532 194.903 130.468C194.923 130.487 194.939 130.529 194.951 130.593Z",
    fill: "#E32C39"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M189.968 125.548C189.932 125.559 189.879 125.551 189.807 125.523C189.84 125.509 189.893 125.518 189.968 125.548Z",
    fill: "#E32C39"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M183.31 125.325C183.287 125.35 183.237 125.373 183.157 125.392C183.176 125.367 183.229 125.345 183.31 125.325Z",
    fill: "#E32C39"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M187.834 125.124C187.842 125.135 187.804 125.129 187.792 125.129C187.792 125.107 187.809 125.101 187.834 125.124Z",
    fill: "#E32C39"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M183.751 125.241C183.749 125.261 183.718 125.28 183.663 125.297C183.663 125.275 183.693 125.255 183.751 125.241Z",
    fill: "#E32C39"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M188.851 125.277C188.834 125.291 188.801 125.286 188.748 125.263C188.762 125.249 188.798 125.252 188.851 125.277Z",
    fill: "#E32C39"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M189.287 125.367C189.27 125.381 189.24 125.375 189.187 125.35C189.204 125.339 189.237 125.345 189.287 125.367Z",
    fill: "#E32C39"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M182.868 125.422C182.865 125.441 182.837 125.458 182.785 125.475C182.787 125.458 182.815 125.439 182.868 125.422Z",
    fill: "#E32C39"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M182.515 125.509C182.512 125.528 182.487 125.545 182.435 125.565C182.437 125.548 182.465 125.528 182.515 125.509Z",
    fill: "#E32C39"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M194.768 129.802C194.748 129.805 194.74 129.785 194.731 129.749C194.751 129.743 194.765 129.763 194.768 129.802Z",
    fill: "#E32C39"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M175.03 131.609C175.041 131.621 175.035 131.637 175.018 131.665C174.996 131.657 174.999 131.637 175.03 131.609Z",
    fill: "#E32C39"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M174.938 131.871C174.952 131.882 174.946 131.905 174.921 131.935C174.899 131.924 174.904 131.902 174.938 131.871Z",
    fill: "#E32C39"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M174.854 132.147C174.866 132.141 174.854 132.18 174.852 132.192C174.832 132.186 174.832 132.169 174.854 132.147Z",
    fill: "#E32C39"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M174.763 132.49C174.774 132.499 174.771 132.515 174.76 132.546C174.738 132.54 174.735 132.521 174.763 132.49Z",
    fill: "#E32C39"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 130.195C222.627 130.15 222.638 130.111 222.68 130.083C222.699 130.128 222.688 130.164 222.644 130.195Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M252.895 139.051C253.097 139.051 253.303 139.031 253.506 139.054C253.625 139.068 253.783 139.112 253.839 139.201C253.925 139.335 253.842 139.48 253.706 139.572C253.672 139.595 253.642 139.628 253.6 139.662C253.633 139.771 253.664 139.877 253.711 140.03C253.595 140.005 253.489 140.013 253.447 139.966C253.358 139.865 253.303 139.734 253.247 139.637C252.97 139.67 253.139 140.055 252.789 140.002C252.831 139.706 252.872 139.413 252.909 139.079C252.9 139.045 252.897 139.048 252.895 139.051ZM253.589 139.366C253.464 139.104 253.317 139.252 253.178 139.302C253.175 139.335 253.175 139.372 253.172 139.405C253.292 139.405 253.408 139.405 253.589 139.366Z",
    fill: "#E63E4B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M253.558 139.385C253.408 139.405 253.292 139.405 253.172 139.405C253.175 139.371 253.175 139.335 253.178 139.302C253.32 139.251 253.464 139.103 253.558 139.385Z",
    fill: "#FBEBEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3693_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.66 62.4) rotate(90) scale(60.7319 30.3659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFBE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86E14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3693_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.678 62.4328) rotate(90) scale(60.2623 30.1312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#351A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3693_13671",
    x1: 3378.3,
    y1: -3260.56,
    x2: 3361.67,
    y2: -3276.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E49F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#E39C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#DC9116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#D88A17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D78817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3693_13671",
    x1: 3383.5,
    y1: 3459.09,
    x2: 3400.13,
    y2: 3443.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3693_13671",
    x1: 2393.56,
    y1: 6597.63,
    x2: 2425.89,
    y2: 6586.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E49F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3693_13671",
    x1: 1188.3,
    y1: 610.478,
    x2: 1190.92,
    y2: 605.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF7312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3693_13671",
    x1: 162.571,
    y1: -128.635,
    x2: 161.531,
    y2: -128.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F0AF13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0AF13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3693_13671",
    x1: 194.584,
    y1: 296.014,
    x2: 195.694,
    y2: 295.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3693_13671",
    x1: 1162.2,
    y1: -442.412,
    x2: 1159.64,
    y2: -447.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3693_13671",
    x1: -701.069,
    y1: -870.728,
    x2: -705.716,
    y2: -866.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D89016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3693_13671",
    x1: 465.455,
    y1: 439.822,
    x2: 467.272,
    y2: 438.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D78817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3693_13671",
    x1: 486.767,
    y1: -570.98,
    x2: 483.581,
    y2: -572.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3693_13671",
    x1: -94.2605,
    y1: 817.705,
    x2: -90.5515,
    y2: 818.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E49F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E49F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3693_13671",
    x1: 151.831,
    y1: 79.9271,
    x2: 147.122,
    y2: 84.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D78817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3693_13671",
    x1: 143.36,
    y1: 83.343,
    x2: 147.087,
    y2: 84.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3693_13671",
    x1: 475.434,
    y1: -595.556,
    x2: 472.08,
    y2: -597.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0AF13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3693_13671",
    x1: 502.796,
    y1: 468.988,
    x2: 504.712,
    y2: 467.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D89016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3693_13671",
    x1: -1294.01,
    y1: 1071.88,
    x2: -1289.05,
    y2: 1079.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#BF7312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3693_13671",
    x1: -1314.54,
    y1: 1142.17,
    x2: -1309.25,
    y2: 1149.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E49F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E49F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D78817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3693_13671",
    x1: 135.712,
    y1: 84.1166,
    x2: 137.173,
    y2: 84.3427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3693_13671",
    x1: -1484.14,
    y1: -1088.48,
    x2: -1489.91,
    y2: -1080.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3693_13671",
    x1: -99.9529,
    y1: -846.927,
    x2: -104.484,
    y2: -845.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F0AF13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0AF13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3693_13671",
    x1: -1429.67,
    y1: 1296.93,
    x2: -1423.59,
    y2: 1304.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A65E0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3693_13671",
    x1: -955.928,
    y1: 1080.04,
    x2: -950.974,
    y2: 1085.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D89016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3693_13671",
    x1: 131.138,
    y1: 83.0844,
    x2: 126.097,
    y2: 84.3882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A65E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F4A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3693_13671",
    x1: 126.205,
    y1: 81.4876,
    x2: 127.714,
    y2: 81.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F0AF13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0AF13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3693_13671",
    x1: 581.558,
    y1: -251.695,
    x2: 579.907,
    y2: -253.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFC20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D78817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D78817"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3693_13671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 29.9712,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3693_13671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.7886,
    height: 46.6,
    fill: "white",
    transform: "translate(116 53.9736)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllsponsor);
export default __webpack_public_path__ + "static/media/Allsponsor.1c0df550f42b1e443febe2e86874fdbe.svg";
export { ForwardRef as ReactComponent };